type Props = {
  html: string;
  title?: string;
  onClose: () => void;
};

export function PreviewModal({ html, title = 'Email preview', onClose }: Props) {
  return (
    <div
      onClick={onClose}
      style={{
        position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.7)', zIndex: 100,
        display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24,
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          background: 'var(--surface)', border: '1px solid var(--border)', borderRadius: 12,
          width: '100%', maxWidth: 720, height: '90vh', display: 'flex', flexDirection: 'column',
        }}
      >
        <div style={{
          display: 'flex', justifyContent: 'space-between', alignItems: 'center',
          padding: 16, borderBottom: '1px solid var(--border)',
        }}>
          <strong>{title}</strong>
          <button className="secondary" onClick={onClose}>Close</button>
        </div>
        <iframe
          title={title}
          srcDoc={html}
          style={{ flex: 1, border: 0, background: '#0f172a' }}
        />
      </div>
    </div>
  );
}
